
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "f104060b6eba4aa05e6e13bd0e9c7394bade5cc1",
  "nuxt": {
    "buildId": "ce95d611-f771-4b76-8ab8-251aad885672"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
